import { type ReactNode } from 'react';

// Added ai variant for convenience based on spec
type BadgeVariant = 'active' | 'waiting' | 'resolved' | 'ai';

interface BadgeProps {
  variant: BadgeVariant;
  children: ReactNode;
}

const variantStyles: Record<BadgeVariant, string> = {
  active: 'bg-accent-success/10 text-accent-success border border-accent-success/20',
  waiting: 'bg-accent-warning/10 text-accent-warning border border-accent-warning/20',
  resolved: 'bg-surface-subtle text-text-secondary border border-border-subtle',
  ai: 'bg-accent-ai/10 text-accent-ai border border-accent-ai/20',
};

export function Badge({ variant, children }: BadgeProps): JSX.Element {
  const baseStyles = [
    'inline-flex items-center',
    'px-2.5 py-0.5',
    'text-xs font-medium',
    'rounded-full',
  ].join(' ');

  return (
    <span className={`${baseStyles} ${variantStyles[variant]}`}>
      {children}
    </span>
  );
}
